import React from "react";

import { faSparkles } from "@fortawesome/pro-solid-svg-icons";

import { ButtonStandard } from "@performyard/py-components";

type PreMeetingPrepButtonProps = {
	onClick: () => void;
};

const PreMeetingPrepButton = ({ onClick }: PreMeetingPrepButtonProps): React.ReactElement => {
	return (
		<div className="flex-shrink-0">
			<ButtonStandard
				variant="solid"
				color="primary"
				size="medium"
				iconRight={faSparkles}
				onClick={onClick}
				dangerouslySetClassName="w-auto"
			>
				Pre-Meeting Prep
			</ButtonStandard>
		</div>
	);
};

export default PreMeetingPrepButton;
